import React, {useRef} from "react"
import { userLogin, useUserDispatch, useUserState } from "../context"

export const LoginPage = (props) => {
    const userDispatch = useUserDispatch()
    const {loadingForLogin} = useUserState()

    const inputID = useRef("")
    const inputPassword = useRef("")


    const on_submit =e=>{
        e.preventDefault()
        const loginPayload = {id:inputID.current.value, password:inputPassword.current.value}
        userLogin(userDispatch, loginPayload)
        .then( res => {
            console.log(res)
            if( res ) props.history.push('/')
            else alert("알 수 없는 오류가 발생했습니다.") //여기로 진입 불가
        })
        .catch(error=>{
            console.log(error)
            if( error.message === 'system'){
                alert("시스템 오류 입니다. 관리자에게 문의하세요")
            }else if( error.message === 'no user'){
                alert('아이디나 비밀번호를 확인하세요')
            }else{
                alert('알 수 없는 오류가 발생했습니다.')
            }
        })
    }

    return(
        <div className="loginPage">
            <div className="logo">Insight Dream<br/>Back Office System</div>
            <div className="title">Login</div>

            <form onSubmit={on_submit}>
                <input type="text" ref={inputID} placeholder="ID*"></input>
                <input type="password" ref={inputPassword} placeholder="PASSWORD*"></input>
                <button disabled={loadingForLogin}>Login</button>
            </form>
        </div>
    )
}